import React, {useContext, useEffect, useState} from 'react';
import SlidingPanel from 'react-sliding-side-panel';
import {MapContext} from "../../../context/MapContext";
import layerSwitcherIcon from '../../../assets/images/mapbox_controls/layer-switcher.png';
import LayerLayoutControl from "./LayerLayoutControl";

/**
 * Set render custom control Layer switcher Panel
 * @returns {JSX.Element}
 * @constructor
 */
const LayerSwitcherPanel = ({
                                openPanel
                            }) => {
    const {mapContext, dispatch} = useContext(MapContext);
    const [layers, setLayers] = useState(null)

    useEffect(() => {
        openPanel.show &&
        mapContext.map && setLayers(mapContext.map.getStyle().layers
            .filter(
                layer => layer.metadata &&
                    layer.metadata.layertype === 'Types de zone'));
    }, [mapContext.map, openPanel.show])

    return (
        <div id={'layer-switcher-panel'}>
            <SlidingPanel
                type={'left'}
                isOpen={openPanel.show}
                size={30}
                backdropClicked={() => dispatch({type: "TOGGLE_LAYER_SWITCHER_DISPLAY"})}
                panelContainerClassName={"panel-container"}
                panelClassName={"panel-content-switcher"}
            >
                <div className={'row title-container'}>
                    <div className={'icon'}>
                        <img src={layerSwitcherIcon} alt="Types de zones icone"/>
                    </div>
                    <div className={'title'}>
                        Types de zone
                    </div>
                    <div className={'close-action'}>
                        <div className={' icon-close'} onClick={() => {
                            dispatch({type: "TOGGLE_LAYER_SWITCHER_DISPLAY"})
                        }}>
                            <i className={'far fa-times-circle'} aria-label={'Fermer'}/>
                        </div>
                    </div>
                </div>
                <div className={'container-layers'}>
                    {
                        layers && layers.length !== 0
                        && layers
                            .filter(layer => layer && layer.metadata && !layer.metadata.lockvisibility).length > 0
                        &&
                        <>
                            <div className={'subtitle'}>Zones sans notifications</div>
                            {
                                layers
                                    .filter(layer => layer && layer.metadata && !layer.metadata.lockvisibility)
                                    .map(layer => <LayerLayoutControl layer={layer} key={layer.id}/>)
                            }
                        </>
                    }
                    {
                        layers && layers.length !== 0
                        && layers
                            .filter(layer => layer && layer.metadata && layer.metadata.lockvisibility).length > 0
                        &&
                        <>
                            <div className={'subtitle'}>Zones avec notifications</div>
                            {
                                layers
                                    .filter(layer => layer && layer.metadata && layer.metadata.lockvisibility)
                                    .map(layer => <LayerLayoutControl layer={layer} key={layer.id}/>)
                            }
                        </>
                    }
                    {
                        layers &&
                        layers.length === 0
                        &&
                        <div className={'global-text-left-invert'}>
                            <i className="fas fa-exclamation-triangle"/>
                            <span className={'px-2'}> Aucune zone chargée</span>
                        </div>
                    }
                </div>
            </SlidingPanel>
        </div>
    );
};

export default LayerSwitcherPanel;